/* This file is autogenerated, see readme.md for instructions */
import VoucherSvgIcon from '@bloomreach/banana-theme/icons/voucher.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const VoucherIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <VoucherSvgIcon />
    </Icon>
  );
});

VoucherIcon.displayName = 'VoucherIcon';

export default VoucherIcon;
